import React from 'react';
import ReactDOM from 'react-dom/client';
import AnyCraveMockup from './anycrave_mockup.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AnyCraveMockup />
  </React.StrictMode>
);
